module.exports = __webpack_public_path__ + "img/3office3.6b06ae8c.jpg";